import React from "react";

/** 배포 직후 '낡은 탭' 청크 소실(dynamic import 404) 판정 — 새 배포가 나가면
 * 열려 있던 이전 버전 탭이 옛 해시 청크를 찾다 실패한다. 새로고침이 정답. */
const CHUNK_ERROR_RE =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError/i;
const RELOAD_KEY = "chunk_reload_at";

export function isStaleChunkError(error) {
  return CHUNK_ERROR_RE.test(String(error?.message || error || ""));
}

/** 자동 새로고침 1회 — 30초 내 재발이면 진짜 장애로 보고 에러 UI 로 넘긴다 */
export function reloadOnceForStaleChunk() {
  let last = 0;
  try { last = Number(sessionStorage.getItem(RELOAD_KEY) || 0); } catch { /* noop */ }
  if (Date.now() - last < 30_000) return false;
  try { sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch { /* noop */ }
  window.location.reload();
  return true;
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
    // 배포 후 낡은 탭의 청크 404 는 사용자 잘못이 아님 — 조용히 새 버전으로 갱신
    if (isStaleChunkError(error) && reloadOnceForStaleChunk()) return;
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            fontFamily: "'Pretendard','Noto Sans KR',sans-serif",
            background: "var(--bg-primary, #fff)",
            color: "var(--text-primary, #111)",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
          <h2 style={{ marginBottom: "8px" }}>화면을 표시할 수 없습니다</h2>
          <p
            style={{
              color: "var(--text-secondary, #666)",
              marginBottom: "24px",
              textAlign: "center",
              maxWidth: "400px",
            }}
          >
            예상치 못한 오류가 발생했습니다. 다시 시도하거나 대시보드로 이동해주세요.
          </p>
          <details
            style={{
              marginBottom: "24px",
              maxWidth: "600px",
              fontSize: "12px",
              color: "var(--text-secondary, #999)",
            }}
          >
            <summary style={{ cursor: "pointer" }}>에러 상세</summary>
            <pre
              style={{
                whiteSpace: "pre-wrap",
                marginTop: "8px",
                padding: "12px",
                background: "var(--bg-secondary, #f5f5f5)",
                borderRadius: "4px",
                overflow: "auto",
              }}
            >
              {this.state.error?.toString()}
              {"\n\n"}
              {this.state.error?.stack}
            </pre>
          </details>
          <div style={{ display: "flex", gap: "12px" }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: "10px 20px",
                background: "#f97316",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              다시 시도
            </button>
            <button
              onClick={this.handleHome}
              style={{
                padding: "10px 20px",
                background: "var(--bg-secondary, #e5e5e5)",
                color: "var(--text-primary, #111)",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              대시보드로
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
